import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Select, Button, Form } from 'antd';
import { getStates } from "../features/statecity/statecitySlice";
import { getVacantList } from "../features/vacantposition/vacantSlice";
import { ExportOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";

const { Option } = Select;

const columns = [
  {
    title: 'S.No.',
    dataIndex: 'key',
    key: 'key',
    width: 10 
  },
  {
    title: 'State',
    dataIndex: 'state',
    key: 'state'
  },
  {
    title: 'District',
    dataIndex: 'district',
    key: 'district',
  },
  {
    title: 'Vacant Position',
    dataIndex: 'vacantposition',
    key: 'vacantposition',
  },
  {
    title: 'UDISE Code',
    dataIndex: 'school_udise_code',
    key: 'school_udise_code',
  },
  {
    title: 'School Name',
    dataIndex: 'schoolname',
    key: 'schoolname',
  },
  {
    title: 'Trade Name',
    dataIndex: 'trades',
    key: 'trades',
  },
];

const VacantPosition = () => {
  const dispatch = useDispatch();
  const [vacantList, setVacantList] = useState([]);
  const [filteredVacantList, setFilteredVacantList] = useState([]);
  
  useEffect(() => {
    dispatch(getStates());
    dispatch(getVacantList());
  }, [dispatch]);

  const statelistState = useSelector((state) => state.statecity.statelist);
  const vacantlistState = useSelector((state) => state.vacantList.vacantLists);

  useEffect(() => {
    if (vacantlistState && typeof vacantlistState === 'object') {
      const vacantArray = Object.entries(vacantlistState).flatMap(([state, data]) => 
        data.schools.map((school, index) => ({
          key: `${index + 1}`,
          state: school.state,
          district: school.district,
          school_udise_code: school.UDISE_Code,
          schoolname: school.school_name,
          trades: school.trades.join(", "),
          vacantposition: 1
        }))
      );
      setVacantList(vacantArray);
      setFilteredVacantList(vacantArray);
    }
  }, [vacantlistState]);

  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    if (values.state_name) {
      const filteredList = vacantList.filter(vacant => vacant.state === values.state_name);
      setFilteredVacantList(filteredList);
    } 
  };

  const handleClear = () => {
    form.resetFields();
    setFilteredVacantList("vacantList"); // Reset to the original vacant list
  };

  const csvHeaders = [
    { label: "State", key: "state" },
    { label: "District", key: "district" },
    { label: "Vacant Position", key: "vacantposition" },
    { label: "School UDISE Code", key: "school_udise_code" },
    { label: "School Name", key: "schoolname" },
    { label: "Trade Name", key: "trades" },
  ];

  return (
    <div style={{ padding: 10 }}>
      <h3 className="mb-4 title">Vacant Position</h3>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 16,
        backgroundColor: "#ffffff",
        border: "1px solid #eef2f6",
        padding: "20px",
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)"
      }}>
        <Form form={form} layout="inline" onFinish={handleSubmit}>
          <Form.Item name="state_name">
            <Select placeholder="Select State" style={{ width: 150, marginRight: 5 }}>
              <Option value="">All States</Option>
              {statelistState.map((i, j) => (
                <Select.Option key={j} value={i.state_name}>
                  {i.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">View</Button>
          </Form.Item>
          <Form.Item>
            <Button onClick={handleClear}>Clear</Button>
          </Form.Item>
        </Form>
      </div>
      <CSVLink data={filteredVacantList} headers={csvHeaders} filename={`Vacant-Positions${new Date().toISOString()}.csv`}>
        <Button type="primary" className="exportcsv" style={{marginBottom: 10}}>
          <ExportOutlined />  Export to CSV
        </Button>
      </CSVLink>
      <Table className="custom-table" columns={columns} dataSource={filteredVacantList} pagination={false} />
    </div>
  );
};

export default VacantPosition;
